import { FONT } from "../../../value/staticValues";
import { numberOfCommas, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { DropdownType } from "../../base/CustomDropdown";
import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import RdsClientPackageAdd from "./RdsClientPackageAdd";
import RdsClientPackageUpdate from "./RdsClientPackageUpdate";


export interface RdsClientPackageData {
    rds_client_package_id: string;
    rds_client_package_name: string;
    rds_client_package_description: string;
    client_version: string;
    os_type_code: string;
    optimal_os_version: string;
    download_uri: string;
    file_name: string;
    file_hash: string;
    latest_yn: boolean;
    create_ts: string;
    update_ts: string;
}


export const initProductData = {
    rds_client_package_id: "",
    rds_client_package_name: "",
    rds_client_package_description: "",
    client_version: "",
    os_type_code: "",
    optimal_os_version: "",
    download_uri: "",
    file_name: "",
    file_hash: "",
    latest_yn: false,
    create_ts: "",
    update_ts: ""
}


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "RDS_CLIENT_PACKAGE_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "RDS_CLIENT_PACKAGE_DELETE",
        },
    }
]


export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_NAME_TEXT"),
        accessor: "rds_client_package_name",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_VERSION_TEXT"),
        accessor: "client_version",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_LATEST_YN_TEXT"),
        accessor: "latest_yn",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <><StatusStableImg style={className.statusImg}/></> : <><StatusBlockImg style={className.statusImg}/></>
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_OS_TEXT"),
        accessor: "os_type_code",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, color: "#0853fb"}}>
                {value == "NONE" ? "-" : value}
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_OS_VERSION_TEXT"),
        accessor: "optimal_os_version",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.greenText}}>{value}
        </div>)
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_FILE_NAME_TEXT"),
        accessor: "file_name",
        disableSortBy: false,
        style: {
            
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
]

export const rdsClientPackageAddModalContent = {
    title: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <RdsClientPackageAdd />,
}

export const rdsClientPackageUpdateModalContent = {
    title: i18n.t("SERVICE_RDS_CLIENT_PACKAGE_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <RdsClientPackageUpdate />,
}


export const osDropdownItem:DropdownType[] = [
    {
        value: "NONE",
        label: "NONE"
    },
    {
        value: "CENTOS",
        label: "CENTOS"
    },
    {
        value: "DEBIAN",
        label: "DEBIAN"
    },
    {
        value: "FEDORA",
        label: "FEDORA"
    },
    {
        value: "RHEL",
        label: "RHEL"
    },
    {
        value: "UBUNTU",
        label: "UBUNTU"
    },
    {
        value: "WINDOWS",
        label: "WINDOWS"
    },
    {
        value: "MACOS",
        label: "MACOS"
    }
]


const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}